// UserContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { getAdminDashboard, getProfile } from '../../services/api';

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
    const [dashboardData, setDashboard] = useState(null);
    const [profileData, setProfile] = useState(null);
    
   
    const dashboard = async () => {
        const result = await getAdminDashboard();
     
        if (result.status === 200) {
            setDashboard(result.data)
       
        } 
        return result.data;
    };
    const profile = async () => {
        const result = await getProfile();

        if (result.status === 200) {
            setProfile(result.data)
        }
        return result;
    };
    return (
        <DashboardContext.Provider value={{ dashboardData, setDashboard, dashboard, profile ,profileData}}>
            {children}
        </DashboardContext.Provider>
    );
};
export const useDashboardContext = () => useContext(DashboardContext);
